<div class="usa-accordion" >
  <h4 class="usa-accordion__heading">
    <button class="usa-accordion__button filter-category-button"
      attr.aria-expanded="{{filterCategory.isExpanded}}"
      (click)="expandClick()"
      arrr.aria-controls="otherPensionList">
      {{title}}
    </button>
  </h4>
  @if (filterCategory.isExpanded) {
    <div id="otherPensionList" class="usa-accordion__content usa-prose content-max-height">
      <ul class="usa-list usa-list--unstyled">
        @for (filterValue of filterCategory.filterValues; track filterValue) {
          <li (click)="rowClick(filterValue)" (keydown.enter)="rowClick(filterValue)" tabindex="0" class="facet-item-row">
            <a  class="usa-link">{{filterValue.displayValue}}
              @if (filterValue.isIndividual) {
                <span class="usa-button--filter-count usa-button" disabled>
                  {{filterValue.count}}
                </span>
              }
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>
